import React, { ForwardedRef, forwardRef } from 'react';

import ModalDialog from './ModalDialog';
import { ModalDialogProps } from './ModalDialogTypes';

// @deprecated
const SubModal = forwardRef(({ children, ...rest }: ModalDialogProps, ref?: ForwardedRef<HTMLDivElement>) => {
    return (
        <ModalDialog {...rest} ref={ref}>
            {children}
        </ModalDialog>
    );
});

export default SubModal;
